<template>

    <div :class="class">
        <h4 class="uppercase tracking-wider text-stone-600 font-normal text-xs">
            <slot>&nbsp;</slot>
        </h4>
    </div>

</template>

<script setup>

    const props = defineProps({
        class: {
            type: String
        }
    })

</script>
